export { cloneOrder } from './clone-order.service';
export { getOrderStatus } from './get-order-status.service';
export {
  type CreateReturnLabelBatchEntryParams,
  createReturnLabelBatchEntry,
} from './create-return-label-batch-entry.service';
export { getOrders } from './get-orders.service';
export type { GetOrdersParams, GetOrdersResponseBody } from './get-orders.service.types';

export { updateOrdersTags } from './update-orders-tags.service';
export { removeOrdersTags } from './remove-orders-tags.service';
/**
 * Service for orders using the Orders MicroService.
 */
export const WEB_ORDERS_API = '/web_orders';
